import { render, staticRenderFns } from "./UpdateDetail.vue?vue&type=template&id=430e1dec&scoped=true"
import script from "./UpdateDetail.vue?vue&type=script&lang=js"
export * from "./UpdateDetail.vue?vue&type=script&lang=js"
import style0 from "./UpdateDetail.vue?vue&type=style&index=0&id=430e1dec&prod&lang=scss&scoped=true"
import style1 from "./UpdateDetail.vue?vue&type=style&index=1&id=430e1dec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430e1dec",
  null
  
)

export default component.exports